import {requiredDateFormat, requiredNumber, requiredString, requiredWerteListeObjekt} from "../utils/Validator";

export const createWertelisteSchema = (referenz, isMultiselection, additionalColumns) => {
    let schema;
    if (referenz && isMultiselection) {
        schema = {value: requiredString()};
    } else {
        schema = referenz ? { value: requiredString(), [referenz]: requiredWerteListeObjekt() } : { value: requiredString() };
    }

    if (additionalColumns) {
        for (const columnData of additionalColumns) {
            if (columnData.id === "datumsformat") {
                schema["datumsformat"] = requiredDateFormat();
            }
            else if (columnData.id === "maxZeilenAnzahl") {
                schema["maxZeilenAnzahl"] = requiredNumber();
            }
        }
    }
    return schema;
};
